// src/features/change-lang/model/useChangeLang.ts
'use client';

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { AvailableLangs } from '@/locales';

export const useChangeLang = () => {
  const { i18n } = useTranslation();
  const [lang, setLang] = useState<AvailableLangs>((i18n.language as AvailableLangs) || 'en');

  const onChange = async (newLang: AvailableLangs) => {
    if (i18n.language !== newLang) {
      await i18n.changeLanguage(newLang);
      setLang(newLang);
      // Update <html> if you change idiom in runtime:
      document.documentElement.lang = newLang;
      document.documentElement.dir = newLang === 'ar' ? 'rtl' : 'ltr';
      // keep cookie if you are using :
      document.cookie = `lang=${newLang}; path=/; SameSite=Lax`;
    }
  };

  return { lang, onChange };
};
